import { jsx as _jsx } from "react/jsx-runtime";
import { GlobalEventToasts } from 'web-app/react/global-event/global-event-toasts';
import { useStatusMessageEventListener } from 'web-app/react/global-event/use-status-message-event-listener';
import { isOpen } from 'web-app/react/modals-container/types';
import useTypedSelector from 'signin-app/components/hooks/use-typed-selector';
import { useDispatchCallback } from 'web-app/react/hooks/use-bind-dispatch';
import * as Actions from './actions';
export default () => {
    const events = useTypedSelector(state => state.globalEvent.events);
    const isShowingModals = useTypedSelector(state => isOpen(state.modals.displayedGroupsSettings)); // Currently we're using only 1 modal
    const clearStatus = useDispatchCallback(dispatch => (eventId) => {
        dispatch(Actions.clearStatus.action(eventId));
    }, []);
    const updateStatus = useDispatchCallback(dispatch => ({ message, statusType, sticky, duration, e2eId }) => {
        dispatch(Actions.updateStatus.action(message, statusType, sticky, duration, e2eId));
    }, []);
    useStatusMessageEventListener(updateStatus);
    return (_jsx(GlobalEventToasts, { events: events, isShowingModals: isShowingModals, clearStatus: clearStatus, size: "large" }));
};
